module.exports = __webpack_public_path__ + "img/lesson-formats.de2aa79.webp";